import { useToastContext } from "@ttc3k/trekker";
import {
  AssetFile,
  AssetImage,
  OrganizationByIdDocument,
  OrganizationByIdQuery,
  useOrganizationUpdateImagesMutation,
} from "gql/generated";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const useBackOffice = (
  organization: OrganizationByIdQuery["organizationById"],
) => {
  const { t } = useTranslation();
  const { toastFactory } = useToastContext();

  const [isTagModalOpen, setIsTagModalOpen] = useState(false);
  const [isUploadLogoModalOpen, setIsUploadLogoModalOpen] = useState(false);

  const [updateOrganizationLogo] = useOrganizationUpdateImagesMutation({
    refetchQueries: [OrganizationByIdDocument],
    onCompleted: () => {
      // Hack because logo doesn't reload when organizationId query is
      // refetched when adding a logo for the first time
      if (!organization?.logo) {
        setTimeout(() => window.location.reload(), 500);
      }
    },
  });

  const handleUploadComplete = async (
    assets: Partial<AssetImage | AssetFile>[],
  ) => {
    if (assets.length > 0 && organization) {
      try {
        await updateOrganizationLogo({
          variables: {
            id: organization._id,
            imagesToDelete: organization.logo
              ? [organization.logo._id]
              : undefined,
            imagesToKeep: assets[0]._id ? [assets[0]._id] : undefined,
            isLogo: true,
          },
        });
        toastFactory.create({
          title: t("core:SUCCESS"),
          description: t("directory:ORGANIZATION.BACK_OFFICE.LOGO.UPDATED"),
        });
      } catch {
        toastFactory.create({
          title: t("core:ERROR.TITLE"),
          description: t("directory:ORGANIZATION.BACK_OFFICE.LOGO.ERROR"),
        });
      } finally {
        setIsUploadLogoModalOpen(false);
      }
    }
  };
  return {
    onUploadComplete: handleUploadComplete,
    isTagModalOpen,
    setIsTagModalOpen,
    isUploadLogoModalOpen,
    setIsUploadLogoModalOpen,
  };
};
